import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { batch, useDispatch } from 'react-redux';
import moment from 'moment';
import { memo } from 'react';
import { useSelector } from '../../common/react-redux-hooks';
import {
  getAccountsLocations,
  getEntitlementById,
  setEditEntitleName,
  setEditSelectedPropCode,
  getDmaMarkets
} from '../../../actions/entitlementActions';
import { CA_NAV_ERROR_MSG } from '../constants';
import { getDetailByContractId } from '../../../actions/contractAdminActions';
import { CA_ADD_CONTRACT_STATUS_OPTIONS } from '../../../constants';
import EntitlementSave from './components/EntitlementSave';
import EntitlementTable from './components/EntitlementTable';

const Entitlement = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [isloading, setIsLoading] = useState(true);
  useEffect(() => {
    const {
      editEntitlement,
      selectedEntitlementId,
      selectedContractId,
      accountId,
      isTPPAccountSelected,
      propCodes,
    } = props;
    if (editEntitlement) {
      dispatch(getDmaMarkets());
      dispatch(setEditSelectedPropCode([]));
      dispatch(
        getEntitlementById(
          selectedEntitlementId,
          accountId,
          isTPPAccountSelected,
          propCodes
        )
      ).then(() => {
        setIsLoading(false);
      });
    } else {
      batch(() => {
        dispatch(setEditEntitleName(''));
        dispatch(
          getAccountsLocations(
            accountId,
            selectedContractId,
            isTPPAccountSelected
          )
        );
        dispatch(getDetailByContractId(selectedContractId)).then(() => {
          setIsLoading(false);
        });
      });
    }
  }, []);
  const { locations, contracts, addNewFormUnsavedChangeFlag } = useSelector(
    state => ({
      locations: state.contractAdmin.locations,
      contracts: state.contractAdmin.addAccount.contracts,
      addNewFormUnsavedChangeFlag:
        state.contractAdmin.addNewFormUnsavedChangeFlag,
    })
  );

  const [isSuccess, setIsSuccess] = useState('');
  const [locationList, setLocationList] = useState([]);
  const [isSaved, setIsSaved] = useState(false);
  const [slectedContract, setSelectedContract] = useState({});
  const [selectedContractStatus, setSelectedContractStatus] = useState('');
  const [selStudy, setSelStudy] = useState([]);
  const [selProd, setSelProd] = useState([]);
  const [selMarket, setSelMarket] = useState([]);
  const [selMemri, setSelMemri] = useState([]);
  const [selMemriDtos, setSelMemriDtos] = useState([]);
  const [selProp, setSelProps] = useState([]);
  const [prodChanged, setProdChanged] = useState(true);
  const [studyChanged, setStudyChanged] = useState(true);
  const [marketChanged, setMarketChanged] = useState(true);
  const [memriChanged, setMemriChanged] = useState(true);
  const [propCodeChanged, setPropCodeChanged] = useState(true);
  const [reset, setResetForm] = useState(false);
  const [twoYrBackData, setTwoYrBackData] = useState(false);
  const [contractEnd, setContractEnd] = useState('');
  const [selectedLoc, setSelectedLoc] = useState([]);
  const [allLoc, setAllLoc] = useState([]);
  const [propchanged, setPropChanged] = useState(true);
  useEffect(() => {
    const sleContract = contracts.find(
      element => element.contractId === props.selectedContractId
    );
    const status = sleContract
      ? CA_ADD_CONTRACT_STATUS_OPTIONS.find(e => e.value === sleContract.status)
      : '';
    const isTwoYrBackData = sleContract.universityBackData === 'TWOYRBACKDATA';
    const selYear = new Date(sleContract.contractEnd).getFullYear();
    setSelectedContract(sleContract);
    setTwoYrBackData(isTwoYrBackData);
    setContractEnd(selYear);
    setSelectedContractStatus(status);
  }, [props.selectedContractId, contracts]);

  const handleLoc = loc => {
    const locStored = loc;
    setSelectedLoc(locStored);
  };

  const handleAllLoc = allLoc => {
    const allLocStored = allLoc;
    setAllLoc(allLocStored);
  };
  useEffect(() => {
    setLocationList(cloneDeep(locations));
  }, [locations]);

  const [saveError, setSaveError] = useState({
    status: false,
    message: '',
  });
  useEffect(() => {
    if (addNewFormUnsavedChangeFlag) {
      setSaveError({
        status: false,
        message: '',
      });
      setIsSuccess('');
    }
  }, [addNewFormUnsavedChangeFlag]);

  return (
    <div>
      {!isloading && (
        <div
          ref={ref}
          className="ent-content"
          id="stickytypeheader"
          data-test="Entitlement"
        >
          {slectedContract && (
            <div className="ent-header">
              <div
                className="ent-header-first-item"
                title={slectedContract.contractName}
              >
                <span className="ent-header-first-item-heading">
                  Contract&nbsp;
                </span>
                <span>{slectedContract.contractName}</span>
              </div>
              <div className="ent-header-other-item">
                <span className="ent-header-other-item-heading">
                  Contract Number&nbsp;
                </span>
                <span>{slectedContract.contractNumber}</span>
              </div>
              <div className="ent-header-other-item">
                <span className="ent-header-other-item-heading">
                  Status&nbsp;
                </span>
                <span>
                  {selectedContractStatus ? selectedContractStatus.label : ''}
                </span>
              </div>
              <div className="ent-header-other-item">
                <span className="summary-header-other-item-heading">Term</span>{' '}
                <span>
                  {slectedContract.contractStart
                    ? moment(slectedContract.contractStart).format('MM/DD/YYYY')
                    : null}{' '}
                  -{' '}
                  {slectedContract.contractEnd
                    ? moment(slectedContract.contractEnd).format('MM/DD/YYYY')
                    : null}
                </span>
              </div>
            </div>
          )}
          {(saveError.status || isSuccess) && (
            <div className="">
              {saveError.status && (
                <div className="ent-save-btn-error">
                  <span>{saveError.message}</span>
                </div>
              )}
              {isSuccess ? (
                <div className="ent-save-btn-success">
                  <span>{isSuccess}</span>
                </div>
              ) : (
                ''
              )}
            </div>
          )}
          {addNewFormUnsavedChangeFlag && !saveError.status && (
            <div className="">
              <div className="ent-save-btn-error">
                <span>{CA_NAV_ERROR_MSG}</span>
              </div>
            </div>
          )}
          <EntitlementSave
            ref={ref}
            locations={locationList}
            studyData={selStudy}
            prodData={selProd}
            selectedPropCodes={selProp}
            setLocationList={setLocationList}
            markets={selMarket}
            memris={selMemri}
            memriDtos={selMemriDtos}
            setIsSaved={setIsSaved}
            setSaveError={setSaveError}
            setIsSuccess={setIsSuccess}
            prodChanged={prodChanged}
            studyChanged={studyChanged}
            marketChanged={marketChanged}
            memriChanged={memriChanged}
            propCodeChanged={propCodeChanged}
            setResetForm={setResetForm}
            handleLoc={handleLoc}
            handleAllLoc={handleAllLoc}
            propchanged={propchanged}
          />
          <EntitlementTable
            isSaved={isSaved}
            twoYrBackData={twoYrBackData}
            contractEnd={contractEnd}
            setSelProd={setSelProd}
            setSelStudy={setSelStudy}
            setStudyChanged={setStudyChanged}
            setSelProps={setSelProps}
            setSelMarket={setSelMarket}
            setSelMemri={setSelMemri}
            setSelMemriDtos={setSelMemriDtos}
            setMarketChanged={setMarketChanged}
            setMemriChanged={setMemriChanged}
            setProdChanged={setProdChanged}
            setPropCodeChanged={setPropCodeChanged}
            reset={reset}
            selectedLoc={selectedLoc}
            allLoc={allLoc}
            setPropChanged={setPropChanged}
          />
        </div>
      )}
    </div>
  );
});
Entitlement.propTypes = {
  editEntitlement: PropTypes.bool,
  selectedEntitlementId: PropTypes.number,
  selectedContractId: PropTypes.number,
  accountId: PropTypes.number,
  isTPPAccountSelected: PropTypes.bool,
  propCodes: PropTypes.arrayOf(PropTypes.object),
};
export default memo(Entitlement);
